import { gql } from '@apollo/client';

const ADMIN_CONSOLE_ROLE_FRAGMENT =  gql`
  fragment AdminConsoleRole on VOLUNTEER_ActivityRoleType {
    activityRoleId
    name
    icon
    description
    canApply
    applicationMode
    allowReapply
  }
`;

export const ADMIN_CONSOLE_ROLE_QUERY = gql `
  query GetAdminConsoleRoles {
    vm {
      activityRoles {
        ...AdminConsoleRole
      }
    }
  }
  ${ADMIN_CONSOLE_ROLE_FRAGMENT}
`

export const INCOMING_ROLE_APPLY_QUERY = gql `
  query GetIncomingRoleApply {
    vm {
      activityRoles(canApply: true) {
        ...AdminConsoleRole
      }
    }
  }
  ${ADMIN_CONSOLE_ROLE_FRAGMENT}
`
